import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AutoRedirect = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      const dashboardType = localStorage.getItem('dashboard_type');
      const redirectUrl = localStorage.getItem('redirect_url');
      
      console.log('AutoRedirect - User:', user);
      console.log('AutoRedirect - Dashboard type:', dashboardType);
      console.log('AutoRedirect - Redirect URL:', redirectUrl);

      // Déterminer la redirection basée sur le rôle et la zone
      if (['admin', 'sgd', 'apd', 'tgd', 'mcd'].includes(user.role)) {
        navigate('/dashboard');
      } else if (user.role === 'membre') {
        navigate('/member-dashboard');
      } else if (user.zone && ['apz', 'sgz', 'tgz', 'mcz', 'moderateur'].includes(user.role)) {
        navigate('/zone-dashboard');
      } else if (redirectUrl) {
        navigate(redirectUrl);
      } else {
        navigate('/dashboard');
      }
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirection en cours...</p>
        {user && (
          <div className="mt-4 text-sm text-gray-500">
            <p>Utilisateur: {user.first_name} {user.last_name}</p>
            <p>Rôle: {user.role}</p>
            <p>Zone: {user.zone || 'Aucune'}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AutoRedirect;